import { isSharedStation } from '@app/core/stations/helpers';
import { MinimumStation, Station } from '@mi-front/core';
import EmergencyIcon from '@mui/icons-material/Emergency';
import { Chip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import { sharedStationTooltipMessage } from './station-messages';

interface SharedStationChipProps {
  station?: Station | MinimumStation | null;
  sx?: SxProps<Theme>;
}

/**
 * Renders a shared-station chip when the station has SHARED access type.
 */
export function SharedStationChip({ station, sx }: SharedStationChipProps) {
  const { $t } = useIntl();

  if (!station || !('accessType' in station) || !isSharedStation(station as Station)) {
    return null;
  }

  return (
    <Chip
      label={$t(sharedStationTooltipMessage)}
      size="small"
      variant="outlined"
      icon={<EmergencyIcon />}
      sx={
        [
          {
            fontWeight: 400,
          },
          sx,
        ] as SxProps<Theme>
      }
    />
  );
}
